export const GET_USERROLES = "GET_USERROLES";
export const ADD_USERROLE = "ADD_USERROLE";
export const EDIT_USERROLE = "EDIT_USERROLE";
export const GET_USERROLE = "GET_USERROLE";
export const RESET_USERROLE = "RESET_USERROLE";
export const ERROR_USERROLE = "ERROR_USERROLE";
export const GET_ALL_USERROLES = "GET_ALL_USERROLES";
                